import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, message } from 'antd';
import { adminGetTrainingById } from '../services/adminService';
import EditObjectiveProgram from './EditObjectiveProgram';
import EditSubjectiveProgram from './EditSubjectiveProgram';
import EditTrainerLedProgram from './EditTrainerLedProgram';
import EditAINestedProgram from './EditAINestedProgram';

const EditProgram: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [programType, setProgramType] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            fetchProgramType();
        }
    }, [id]);

    const fetchProgramType = async () => {
        try {
            setLoading(true);
            const training = await adminGetTrainingById(parseInt(id!));
            
            // Determine program type
            if (training.programType === 'TrainerLed') {
                setProgramType('TrainerLed');
            } else if (training.programType === 'AINested') {
                setProgramType('AInested');
            } else {
                // Fallback for legacy programs: subjective uses [desc], objective uses #T
                const a = training.assessments || '';
                if (a.includes('"chapters"') || a.includes('chapters":')) {
                    setProgramType('AInested');
                } else if (a.includes('[')) {
                    setProgramType('Subjective');
                } else {
                    setProgramType('Objective');
                }
            }
        } catch (error) {
            console.error('Error fetching program type for edit:', error);
            message.error('Failed to load program details');
            navigate('/admin');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div style={{ padding: '100px', textAlign: 'center' }}>
                <Spin size="large" tip="Loading editor..." />
            </div>
        );
    }

    if (programType === 'TrainerLed') return <EditTrainerLedProgram />;
    if (programType === 'AInested') return <EditAINestedProgram />;
    if (programType === 'Subjective') return <EditSubjectiveProgram />;
    return <EditObjectiveProgram />;
};

export default EditProgram;
